import React from "react";
import {
  Box,
  Grid,
  Typography
} from "@mui/material";
import { useTheme } from '@mui/material/styles';
import BackgroundImage from "../../assets/img/bg.jpg";
import BackgroundImageDark from "../../assets/img/bg.jpg";
import VerifyUserForm from "./submitForm/VerifyUserForm";
import IMG_LOGO from "../../assets/img/logo.png";
import IMG_LOGO_DARK from "../../assets/img/logo-sticky.png";

const VerifyUser = () => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        backgroundImage: `url(${theme.palette.mode === 'light' ? BackgroundImage : BackgroundImageDark})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        minHeight: '100vh',
        width: '100%'
      }}
    >
      <Grid
        container
        spacing={0}
        direction="column"
        alignItems="center"
        justifyContent="center"
        style={{ minHeight: '100vh' }}
      >
        <Grid
          item
          container
          justifyContent='space-between'
          alignItems='center'
          sx={{ width: '80%' }}
        >
          <Grid item lg={6} sm={6} container direction='column'>
            <Box
              component="img"
              sx={{ width: 300, display: 'flex', textAlign: { xs: 'center', md: 'initial' }, margin: { xs: '0 auto', md: '0' } }}
              src={IMG_LOGO}
              alt="Clientl Logo"
            />
            <Typography sx={{ color: '#fff', fontSize: '1.1rem', fontWeight: '300', textAlign: { xs: 'center', md: 'initial' }, marginTop: '16px', mb: { xs: 3 } }}>
              Advanced provider-client management system.
            </Typography>
          </Grid>
          <Grid item lg={6} sm={6} container justifyContent='end'>
            <VerifyUserForm />
          </Grid>
        </Grid>

      </Grid>
    </Box>
  );
}

export default VerifyUser;
